import PortalIdParser from 'PortalIdParser';
import CrossTabConfig from 'worker-connection-library/calling-cross-tab-utils/CrossTabConfig';
import { _CrossTabManager } from './CrossTabManager';
import { createChannelBroadcastMessage } from '../messages/createBroadcastMessages';
import { HEARTBEAT_REQUEST } from '../types/BroadcastEvents';
export const CALLING_EXTENSIONS_REMOTE_CROSS_TAB = 'calling-extensions-remote-cross-tab';
export class _CrossTabConnectionManager extends _CrossTabManager {
  // Even though the heartbeat is running every second, the difference between
  // `now()` and the heartbeat timestamp is sometimes coming back as over 2 seconds,
  // causing the the tab to be removed and a new master chosen. Extending the
  // threshold to 3 seconds

  // how often to update the tab list.
  // how long before disconnecting tab.

  constructor() {
    super();
    this.heartbeatFrequency = 1000;
    this.heartbeatLossTimeout = 3000;
    this.handleActiveTab = () => {
      this.setLastUpdatedTab();
      this.setTabListData();
    };
    this.heartbeat = () => {
      if (!this.broadcastChannel) {
        return;
      }
      const requestMessage = createChannelBroadcastMessage({
        type: HEARTBEAT_REQUEST,
        payload: {},
        messageRelayChannel: this.broadcastChannel.name,
        originConnectionId: this.getConnectionId()
      });
      this.broadcastChannel.postMessage(requestMessage);
    };
    this.cleanUpIdleTabs = () => {
      const currentTime = Date.now();
      const data = this.getTabListData();
      const updatedData = {};
      let hasChanged = false;
      Object.keys(data).forEach(tabId => {
        if (data[tabId] === 0) {
          hasChanged = true;
        } else if (currentTime - data[tabId] > this.heartbeatLossTimeout) {
          // JavaScript timers are throttled in inactive Chrome tabs
          // Mark tab as disconnected if it hasn't been updated in a while
          updatedData[tabId] = 0;
          hasChanged = true;
        } else {
          updatedData[tabId] = data[tabId];
        }
      });
      if (hasChanged) {
        this.setTabListData(updatedData);

        // Check if tabs are still alive
        this.heartbeat();
      }
    };
    this.onmessage = event => {
      const message = event.data;
      const type = message && message.type;
      if (type === HEARTBEAT_REQUEST && this.getConnectionId() !== message.originConnectionId) {
        this.setTabListData();
      }
    };
    this.closeChannel = () => {
      if (!this.broadcastChannel) {
        return;
      }
      this.broadcastChannel.removeEventListener('message', this.onmessage);
      this.broadcastChannel.close();
    };
    this.stop = () => {
      try {
        window.parent.removeEventListener('focus', this.handleActiveTab);
        document.removeEventListener('visibilitychange', this.handleActiveTab);
      } catch (e) {
        // do nothing
      }
      clearInterval(this.heartbeatTimerId);
      clearInterval(this.heartbeatLossTimerId);
      this.closeChannel();
    };
    this.connectionId = CrossTabConfig.get().connectionId;
    this.storageTabLastUpdatedKey = `Tab_Master-${PortalIdParser.get()}`;
    if ('BroadcastChannel' in window) {
      this.broadcastChannel = new BroadcastChannel(CALLING_EXTENSIONS_REMOTE_CROSS_TAB);
    }
  }
  start() {
    try {
      window.parent.addEventListener('focus', this.handleActiveTab);
      window.parent.document.addEventListener('visibilitychange', this.handleActiveTab);
    } catch (e) {
      // do nothing
    }
    this.handleActiveTab();

    // Tell local storage that current tab is still alive
    this.heartbeatTimerId = window.setInterval(() => {
      this.setTabListData();
    }, this.heartbeatFrequency);
    this.heartbeatLossTimerId = window.setInterval(() => {
      if (this.matchesLastUpdatedTab()) {
        this.cleanUpIdleTabs();
      }
    }, this.heartbeatLossTimeout);
    if (this.broadcastChannel) {
      this.broadcastChannel.addEventListener('message', this.onmessage);
    }
  }
}
export const crossTabConnectionManager = new _CrossTabConnectionManager();